import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: "app-no-order-item",
    templateUrl: "./no-order-item.component.html",
    styleUrl: "./no-order-item.component.scss",
    standalone: false,
})
export class NoOrderItemComponent {
    constructor(private router: Router) {}

    public backToOrders(): void {
        this.router.navigate([`account/trackOrder`]);
    }
}
